import { Alert, AlertIcon, Box, Center, Stack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Card } from "../../components/Cards/BasicCard";
import { Logo } from "../../components/Common/Logo";
import ForgetPasswordForm from "../../components/Forms/ForgetPasswordForm";
import useMutationHandler from "../../hooks/useMutationHandler";
import useQueryHandler from "../../hooks/useQueryHandler";
import { forgetPasswordApi, meApi } from "../../services/user";
import { RQ_USER_KEY } from "../../utils/constants";
import { genericErrorMsg } from "../../utils/helper";

const ForgetPassword = () => {
  let history = useHistory();
  let location = useLocation();
  const [errorMessage, setErrorMessage] = useState("");

  const { mutateAsync, isLoading } = useMutationHandler(forgetPasswordApi, []);
  const {
    data,
    error,
    isLoading: isLoadingQuery,
  } = useQueryHandler(RQ_USER_KEY, meApi);

  useEffect(() => {
    if (!isLoadingQuery) {
      if (!error && data) {
        history.replace("/dashboard/home");
      }
    }
  }, [data, error, isLoadingQuery, history]);

  const handleSubmit = async (values) => {
    try {
      setErrorMessage("");
      await mutateAsync(values, {
        onSuccess: () => {
          let { from } = location.state || {
            from: { pathname: "/login" },
          };
          history.replace(from);
        },
        onError: (err) => {
          throw err;
        },
      });
    } catch (error) {
      const errorMsg = genericErrorMsg(error);
      setErrorMessage(errorMsg);
    }
  };

  const initialValues = {
    email: "",
  };

  return (
    <Box
      as="section"
      bgGradient={{ md: "linear(to-r, blue.600, purple.600)" }}
      minH="100vh"
      py="20"
    >
      <Card maxW="2xl" mx="auto" textAlign="center">
        <Stack maxW="lg" mx="auto" spacing="8">
          <Center>
            <Logo boxSize={{ base: "8rem", md: "10rem" }} />
          </Center>
          {errorMessage && (
            <Alert status="error">
              <AlertIcon />
              {errorMessage}
            </Alert>
          )}
          <ForgetPasswordForm
            isLoading={isLoading}
            handleSubmit={handleSubmit}
            initialValues={initialValues}
          />
        </Stack>
      </Card>
    </Box>
  );
};

export default ForgetPassword;
